/**
 * Agora theme — UI-critical JS entry point.
 *
 * Bevat alleen JavaScript die nodig is om visuele FOUC te voorkomen
 * of die de UI direct interactie-klaar maakt. Deze bundle wordt
 * geladen ZONDER `defer` zodat custom selects, close-button-hover en
 * andere visuele enhancements al staan voordat de pagina visible is.
 *
 * Functionaliteit die pas bij user-interactie (scroll, klik, navigatie)
 * nodig is staat in `main.js` — die mag deferred geladen worden.
 *
 * Geen SCSS-import hier: styling komt via `main.js` (`main.scss`).
 * CSS laadt sowieso render-blocking via een `<link>`-tag dus de
 * styling staat er ook bij defer-JS al, mits het CSS via een aparte
 * `<link>` ge-enqueued is — niet via een JS-side-effect.
 */

import { initCustomSelects } from './modules/ui/custom-select.js';

/**
 * Bootstrap UI-critical modules. Bewust géén `close-button-hover`:
 * die is een hover-micro-interaction (alleen actief bij mouseenter)
 * en gebruikt Motion.js intern (~70kB). Hem hier importeren zou de
 * blocking bundle uit balans halen — hij blijft in `main.js`.
 *
 * Andere interactie-modules (archive AJAX, mobile nav, sticky header,
 * nav submenus) wachten ook op `main.js` (deferred).
 */
function bootstrap() {
    initCustomSelects();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
} else {
    bootstrap();
}
